import { IssueDispositionTypes } from '../../../cimsPage/instances/issues'
import { DispositionTypes } from '../../common'

const { Create, Edit, RemoveRestore, View } = DispositionTypes({
  create: '093095E9-81E5-42D9-91AD-769AB183507C',
  edit: 'B603B45D-5E4F-487E-9D7C-787F73ADFD34',
  view: 'B2135790-68CE-4726-82E5-1113ABDDE43A',
  removeRestore: 'CBE6D786-5F54-4B3F-8CA7-7EF815DC4FD8',
  page: IssueDispositionTypes,
})

export const CreateIssueDispositionType = Create
export const EditIssueDispositionType = Edit
export const RemoveRestoreIssueDispositionType = RemoveRestore
export const ViewIssueDispositionType = View

export type IssueDispositionTypePermission =
  | typeof CreateIssueDispositionType
  | typeof EditIssueDispositionType
  | typeof RemoveRestoreIssueDispositionType
  | typeof ViewIssueDispositionType
